module.exports = __webpack_public_path__ + "img/bongabong-building.c299bd00.jpg";